import type { CopyShape } from "../../intl";

import type { PLAN_CATALOG_COPY_PT_BR } from "../plan-catalog.copy";

export const PLAN_CATALOG_COPY_EN_US: CopyShape<typeof PLAN_CATALOG_COPY_PT_BR> = {
  priceOnRequestLabel: "Custom pricing",
  contactCtaLabel: "Talk to us",
  monthlySuffix: "/mo",
};
